import { SSOPublicApp } from "../../../shared/types";
import { useStore } from "../use-store/useStore";

export function useApp(): SSOPublicApp {
  const store = useStore();

  if (!store.app) {
    throw new Error("No app");
  }

  return store.app;
}
